import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { CommonModule } from '@angular/common';
import {
  ARTICLE_IMAGE_CONTENT_REDUCER_TOKEN,
  articleImageContentReducerProvider,
  rootReducerKey
} from './image-content.reducer';
import { ArticleImageContentEffects } from './image-content.effects';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    StoreModule.forFeature(rootReducerKey, ARTICLE_IMAGE_CONTENT_REDUCER_TOKEN),
    EffectsModule.forFeature([ArticleImageContentEffects])
  ],
  providers: [
    articleImageContentReducerProvider
  ]
})
export class ArticleImageContentStoreModule {
}
